import type { HuntStatus } from './types'

/**
 * The search a link to a hunt's page carries, with Close returning to `from`.
 *
 * The page chooses between the plan, the live view and the ended report from
 * `ended` and `ongoing` alone, so a link without them opens an ended hunt as an
 * unanswered invitation. Every link into the hunt page is built here for that
 * reason.
 */
export function huntDetailSearchFor(
  hunt: { teamId?: string; status: HuntStatus },
  from: string,
): Record<string, string> {
  const search: Record<string, string> = { from }
  if (hunt.teamId) search.teamId = hunt.teamId
  if (hunt.status === 'ended') search.ended = '1'
  if (hunt.status === 'ongoing') search.ongoing = '1'
  return search
}
